export interface ClubTheme {
  id: string;
  name: string;
  metaphor: string;
  colors: {
    primary: string;
    bg: string;
    surface: string;
    text: string;
    accent: string;
    muted: string;
  };
  defaultEmojis: string[];
}

export const sponsorTheme: ClubTheme = {
  id: 'sponsors-club',
  name: 'Sponsors Club',
  metaphor: 'The Lounge',
  colors: {
    primary: '#C4A052',
    bg: '#1A1A1A',
    surface: '#2A2A2A',
    text: '#F5F0E8',
    accent: '#E8D5A3',
    muted: '#6B6560',
  },
  defaultEmojis: ['💛', '🏆', '🤝', '💎', '🎯'],
};

export const teacherTheme: ClubTheme = {
  id: 'teachers-corner',
  name: 'Teachers Corner',
  metaphor: 'The Commons',
  colors: {
    primary: '#B85C38',
    bg: '#FAF6F1',
    surface: '#FFFFFF',
    text: '#3D2C2E',
    accent: '#7D8E6E',
    muted: '#A09890',
  },
  defaultEmojis: ['❤️', '🌟', '📚', '🎉', '👏'],
};

export const combineTheme: ClubTheme = {
  id: 'the-combine',
  name: 'The Combine',
  metaphor: 'The Arena',
  colors: {
    primary: '#0EA5E9',
    bg: '#0F172A',
    surface: '#1E293B',
    text: '#F1F5F9',
    accent: '#38BDF8',
    muted: '#64748B',
  },
  defaultEmojis: ['🔥', '💪', '⚡', '🏅', '🎯'],
};

export const CLUB_THEMES: Record<string, ClubTheme> = {
  'sponsors-club': sponsorTheme,
  'teachers-corner': teacherTheme,
  'the-combine': combineTheme,
};
